<template>
  <ConfirmModal
      color="primary"
      icon="mdi-exclamation"
      :maxWidth="500"
      itemKey="TicketItemComment"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :confirmData="updateStatusImportantData"
      @onConfirm="(response) => $emit('onUpdateStatusImportant', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import TicketItemCommentsAuth from '@/services/ticket-item-comments-auth'

  import ConfirmModal from '@/components/_Part/_Modal/Confirm'

  export default {
    name: 'UpdateStatusImportant',
    props: [
      'id'
    ],
    emits: [
      'onUpdateStatusImportant'
    ],
    components: {
      ConfirmModal
    },
    methods: {
      fetchData() {
        return TicketItemCommentsAuth
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Označiť komentár z ' + this.$moment(Item.createdAt).format('DD.MM.YYYY HH:mm') + ' od ' + Item.Creator.name + ' ako dôležitý'
      },
      setQuestion(Item) {
        return 'Naozaj chcete označiť komentár z ' + this.$moment(Item.createdAt).format('DD.MM.YYYY HH:mm') + ' od ' + Item.Creator.name + ' ako dôležitý?'
      },
      updateStatusImportantData() {
        return TicketItemCommentsAuth
          .updateStatusImportant({
            id: this.id
          })
      }
    }
  }
</script>
